import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import FetchApi from '../React/REST';

const initialState = {
    status: 'idle',
    languages: [],
    error: false
};

export const fetchLang = createAsyncThunk(
    'languages/status',
    async () => {
        const fetchApi = new FetchApi('/languages');
        const response = await fetchApi.get();
        return response;
    }
);

const languagesSlice = createSlice({
    name: 'languages',
    initialState,
    reducers: {},
    extraReducers: {
        [fetchLang.fulfilled]: (state, { payload }) => {
            state.languages = payload;
            state.status = 'load';
        },
        [fetchLang.pending]: (state) => {
            state.status = 'pending';
        },
        [fetchLang.rejected]: (state) => {
            state.status = 'rejected';
        },
    }
});

export default languagesSlice.reducer;

